<div class="content-header {{headerData.style ?? ''}}"
    [ngClass]="{'no-cta': noCta, 'has-bg': hasBgItems}"
    (finderInViewport)="headerVisible()"
>
    <finder-text-logo class="text-logo" *ngIf="headerData?.textLogo"
        [id]="'content-header-text-logo'"
        [a11yText]="headerData.textLogoA11yText"
        [lottie]="headerData.textLogo">
    </finder-text-logo>
    <div class="overtitle" *ngIf="headerData?.header">
        {{ headerData.header }}
    </div>
    <finder-lottie-bg *ngIf="headerData?.bgItems"
        [data]="headerData.bgItems"
        [onTriggerPlayback]="triggerPlayback"
    ></finder-lottie-bg>
    <finder-picture class="header-image" *ngIf="headerData?.picture"
        [picture]="headerData.picture"
    ></finder-picture>
    <div class="header-text"
        [class.has-scroll]="headerData?.titleScroll"
        #headerText
    >
        <finder-scrollimation *ngIf="headerData?.titleScroll"
            [data]="headerData.titleScroll"
            [ngClass]="{'hide': hideAnimation}"
            (scrollEnter)="scrollEnter($event)"
            (scrollLeave)="scrollLeave($event)"
        ></finder-scrollimation>
        <div *ngIf="isDetailPage; else defaultHeaders">
            <h2 *ngIf="headerData.title"
                class="title desktop-{{headerData.titleAlignment}} mobile-{{headerData.mobileTitleAlignment}}"
                finderAriaLabelHtml
                [ngClass]="{'cta-margin': needsMargin, 'hide': hideText}"
                [innerHTML]="headerData.title | safeHtml"></h2>
            <h3 *ngIf="headerData.subtitle"
                class="subtitle desktop-{{headerData.subtitleAlignment}} mobile-{{headerData.mobileSubtitleAlignment}}"
                finderAriaLabelHtml
                [ngClass]="{'hide': hideText}"
                [innerHTML]="headerData.subtitle | safeHtml"></h3>
            <h4 *ngIf="headerData.text"
                class="text desktop-{{headerData.textAlignment}} mobile-{{headerData.mobileTextAlignment}}"
                finderAriaLabelHtml
                [ngClass]="{'hide': hideText}"
                [innerHTML]="headerData.text | safeHtml"></h4>
        </div>
        <ng-template #defaultHeaders>
            <h1 *ngIf="headerData.title"
                class="title desktop-{{headerData.titleAlignment}} mobile-{{headerData.mobileTitleAlignment}}"
                finderAriaLabelHtml
                [ngClass]="{'cta-margin': needsMargin, 'hide': hideText}"
                [innerHTML]="headerData.title | safeHtml"></h1>
            <div *ngIf="hasSponsor" class="sponsor">
                <span>{{ headerData.sponsorMedia.text }}</span>
                <finder-picture [picture]="sponsorImage"></finder-picture>
            </div>
            <h2 *ngIf="headerData.subtitle"
                class="subtitle desktop-{{headerData.subtitleAlignment}} mobile-{{headerData.mobileSubtitleAlignment}}"
                finderAriaLabelHtml
                [ngClass]="{'hide': hideText}"
                [innerHTML]="headerData.subtitle | safeHtml"></h2>
            <h3 *ngIf="headerData.text"
                class="text desktop-{{headerData.textAlignment}} mobile-{{headerData.mobileTextAlignment}}"
                finderAriaLabelHtml
                [ngClass]="{'hide': hideText}"
                [innerHTML]="headerData.text | safeHtml"></h3>
        </ng-template>
    </div>
    <div class="header-image-drawer" *ngIf="headerData.imageDrawer">
        <finder-image-drawer
            [data]="headerData.imageDrawer.data">
        </finder-image-drawer>
    </div>
    <div class="header-cta" *ngIf="headerData.ctaEnabled === true">
        <finder-multi-cta
            [data]="headerData.cta"
        ></finder-multi-cta>
    </div>
    <div class="header-email" *ngIf="headerData.ctaEmailEnabled === true">
        <finder-email-capture
            [emailData]="headerData.cta"
        ></finder-email-capture>
    </div>
    <div class="header-message" *ngIf="headerData.pageMessage">
        <finder-page-message [backgroundColor]="headerData.pageMessage.backgroundColor">
            <span class="dynamic-html" [innerHTML]="headerData.pageMessage.message | safeHtml"></span>
        </finder-page-message>
    </div>
    <div class="header-lottie" *ngIf="headerData.headerLottie">
        @defer {
            <finder-lottie
                [data]="headerData.headerLottie">
            </finder-lottie>
        }
    </div>
    <div class="disclaimer" *ngIf="headerData.disclaimer">
        <finder-disclaimer [disclaimer]="headerData.disclaimer" [alignment]="headerData"></finder-disclaimer>
    </div>
</div>
